module.exports = __webpack_public_path__ + "static/landing-page-video-screenshot-a02aa646d1c675e8d8d8555bb66dc8cd.jpg";